<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-form ref="sendInvoiceForm" v-model="sendInvoiceForm">
        <v-text-field
            :label="languageData.labels.email"
            :rules="[
                  v => !!v || languageData.validateSendEmailForm.email_required,
                  v => /.+@.+\..+/.test(v) || languageData.validateSendEmailForm.email_valid
            ]"
            :placeholder="languageData.labels.email"
            outlined
            clearable
            :clear-icon-cb="clearText"
            v-model="data.email"
        >
        </v-text-field>
        <input hidden> <!-- Only for bypass form submission on enter -->
        <div class="d-flex justify-end">
          <v-btn
              class="button-shadow"
              color="primary"
              :loading="emailIsSending"
              @click="submitAndSend">
            {{ languageData.labels.send }}
          </v-btn>
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data () {
    return {
      data: {
        email: ''
      },
      validForm: false,
      sendInvoiceForm: false,
    }
  },
  computed: {
    ...mapState("sendInvoice", {
      invoice: state => state.invoice,
      dataSendIsFetching: state => state.dataSendIsFetching,
      emailIsSending: state => state.emailIsSending
    })
  },
  methods: {
    ...mapActions('sendInvoice', ["sendInvoice"]),
    submitAndSend() {
      if(this.$refs.sendInvoiceForm.validate()) {
        this.sendInvoice({ creds: {
            email: this.data.email,
            invoice: this.invoice,
          }});
      }
    },
    clearText() {
      this.$refs.sendInvoiceForm.reset();
    }
  },
}

</script>